export const publishApiToNewRelic = ({ action, output }) => {
  LIFE_CYCLE_EVENT_BUS.trigger(`rental-api-sources.${action}`, output);
};

export const publishToNewRelic = ({ action, output }) => {
  LIFE_CYCLE_EVENT_BUS.trigger(`rental-estimate.${action}`, output);
};
